import { render, staticRenderFns } from "./HDORecord.vue?vue&type=template&id=231c08d8&scoped=true"
import script from "./HDORecord.vue?vue&type=script&lang=js"
export * from "./HDORecord.vue?vue&type=script&lang=js"
import style0 from "./HDORecord.vue?vue&type=style&index=0&id=231c08d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c08d8",
  null
  
)

export default component.exports